import { createContext, useContext } from 'react'

/** Set by `ToastProvider`. The provider lives in `Toast.jsx`. */
export const ToastContext = createContext(null)

/**
 * Feedback for actions that used to complete in silence.
 *
 *   const toast = useToast()
 *   toast.success(S.deleted)
 *   toast.error(S.deleteFailed)
 *
 * Outside a provider the calls are no-ops, so a component can be previewed on its
 * own without wiring one up.
 */
export function useToast() {
  return useContext(ToastContext) ?? NO_TOASTS
}

const noop = () => {}
const NO_TOASTS = { push: noop, success: noop, error: noop, info: noop }
